import React from 'react';
import Modal from 'Utils/Modal';
import * as actions from 'Actions';
import { connect } from 'react-redux';
import Endpoints from 'Api/endpoints';
import SerializedInventoryTable from 'Utils/SerializedInventoryTable';
import {
  handleResponse,
  searchSerializedProducts,
  sortSerializedProducts,
} from 'Utils/SerializedProducts';
import LoadingSpinner from 'Utils/LoadingSpinner';
import Infinite from 'react-infinite';
import BarcodeReader from '../../BarcodeReader/BarcodeReaderComponent';

class SerializedUniquePickModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: [],
      serializedProducts: [],
      serialNumber: '',
      isSerializedMode: true,
      pickedQuantity: '',
      usageUnits: props.product ? props.product.usageUnits : [],
      textValues: { notes: '' },
      direction: false,
      loading: false,
      searching: false,
      pagination: {},
      barcodeInput: false,
      lastScannedSerial: null,
    };
  }

  componentDidMount() {
    if (this.props.product && this.props.product.usageUnits) {
      const { usageUnits } = this.props.product.usageUnits;

      this.fetchSerializedProducts();

      usageUnits &&
        usageUnits.length > 0 &&
        usageUnits.map((unit) => {
          this.setState({
            textValues: {
              ...this.state.textValues,
              [unit.name]: '',
            },
          });
        });
    }
  }

  fetchSerializedProducts() {
    const { product, item, rental } = this.props;

    this.setState({ loading: true });

    Endpoints.serializedProducts
      .fetchSerializedProductsForCheckOut(product, rental.token)
      .then((response) => {
        if (response.data && response.data !== null) {
          const pagination = response.data.meta.pagination;
          let serializedProducts = response.data.serializedProducts;

          const { newSerializedProducts, newSelected } = handleResponse(
            serializedProducts,
            item,
            'checkOut',
            this.state
          );

          this.setState({
            selected: newSelected,
            serializedProducts: newSerializedProducts,
            pagination,
          });
        }
      })
      .catch((error) => {
        const { setErrors } = this.props;
        const errors = error?.response?.data;
        setErrors(errors);
      })
      .finally(() => {
        this.setState({ loading: false });
        this.sortBySelected();
      });
  }

  fetchSerializedProductsFromLink(link) {
    const { item } = this.props;

    this.setState({ loading: true });

    Endpoints.serializedProducts
      .fetchSerializedProductsFromLink(link)
      .then((response) => {
        if (response.data && response.data !== null) {
          const pagination = response.data.meta.pagination;
          let serializedProducts = response.data.serializedProducts;

          const { newSerializedProducts, newSelected } = handleResponse(
            serializedProducts,
            item,
            'checkOut',
            this.state
          );

          this.setState({
            selected: newSelected,
            serializedProducts: newSerializedProducts,
            pagination,
          });
        }
      })
      .catch((error) => {
        const { setErrors } = this.props;
        const errors = error?.response?.data;
        setErrors(errors);
      })
      .finally(() => {
        this.setState({ loading: false, searching: false });
      });
  }

  addRows = () => {
    const { pagination } = this.state;

    this.setState({ searching: true });

    if (pagination?.links?.next) {
      const link = pagination.links.next;

      this.fetchSerializedProductsFromLink(link);
    } else {
      this.setState({ loading: false, searching: false });
    }
  };

  getDataFromSerialNumber = async (value) => {
    const { product } = this.props;
    const serialNumber = value.trim();

    return Endpoints.serializedProducts
      .showBySerialNumber(product, serialNumber)
      .then((response) => {
        if (response.data && response.data !== null) {
          let { serializedProduct } = response.data;
          serializedProduct = {
            ...serializedProduct,
            checkOut: serializedProduct?.usageWithUnitDetails?.map((unit) => ({
              id: unit.unitId,
              label: unit.unitName,
              value: unit.usage,
              type: unit.unitType,
            })),
            checked: true,
          };
          return serializedProduct;
        } else {
          this.props.setErrorMessage({
            field: 'selected',
            text: `Serial Number ${serialNumber} not found`,
          });
          return {};
        }
      })
      .catch((error) => {
        this.props.setErrorMessage({
          field: 'selected',
          text: `Serial Number ${serialNumber} not found`,
        });
        return {};
      });
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  closeModal = () => {
    const { toggle } = this.props;
    toggle();
  };

  performSearch = async (event) => {
    event && event.preventDefault();
    const { selected, serializedProducts } = this.state;
    let { serialNumber } = this.state;

    serialNumber = serialNumber.trim();

    this.setState({ searching: true });

    let newSerializedProducts = searchSerializedProducts(
      serialNumber,
      selected,
      serializedProducts
    );

    const isIncluded = newSerializedProducts.filter(
      (serializedProduct) => serializedProduct.serialNumber === serialNumber
    );

    if (isIncluded.length == 0) {
      let missingSerializedProduct;
      missingSerializedProduct =
        await this.getDataFromSerialNumber(serialNumber);

      if (!!missingSerializedProduct.serialNumber) {
        newSerializedProducts = [
          ...newSerializedProducts,
          missingSerializedProduct,
        ];
      }
    }

    const newSelected = newSerializedProducts.filter(
      (serializedProduct) => serializedProduct.checked
    );

    this.setState({
      serializedProducts: newSerializedProducts,
      selected: newSelected,
      serialNumber: '',
      searching: false,
    });
  };

  handleSubmit = () => {
    const { isSerializedMode } = this.state;
    const { afterSubmit } = this.props;
    if (isSerializedMode) {
      this.handleSerializedSubmit();
    } else {
      this.handleStandardSubmit();
    }
    if (afterSubmit) afterSubmit();
  };

  handleSerializedSubmit = () => {
    const { selected } = this.state;
    const { rental, item, serializedPickRentalItemWithUsage, toggle } =
      this.props;

    // Validation
    if (selected.length === 0) {
      this.props.setErrorMessage({
        field: 'selected',
        text: 'You need to select at least one serialized item.',
      });
    } else if (selected.length > item.quantity) {
      this.props.setErrorMessage({
        field: 'selected',
        text: 'Cannot checkout more items than rented.',
      });
    } else {
      const pickedQuantity = selected.length;
      const pickedIds = selected.map((s) => s.id);

      const usageValues = selected.map((item) => {
        return {
          serialized_product_id: item.id,
          unit: item.checkOut.map((usage) => {
            if (usage !== undefined && usage.value !== undefined) {
              return { id: usage.id, usage: usage.value };
            }
          }),
          notes: item.notes,
        };
      });

      serializedPickRentalItemWithUsage(
        rental.id,
        item.id,
        pickedQuantity,
        pickedIds,
        usageValues
      );
      toggle();
    }
  };

  handleStandardSubmit = () => {
    const { pickedQuantity } = this.state;

    // Validation
    if (pickedQuantity < 0 || pickedQuantity > this.props.item.quantity) {
      this.props.setErrorMessage({
        field: 'pickedQuantity',
        text: 'Cannot checkout more than reserved',
      });
    } else {
      const { rental, item, pickRentalItem, toggle } = this.props;
      pickRentalItem(rental.id, item.id, pickedQuantity);
      toggle();
    }
  };

  toggleIsSerializedMode = () => {
    this.setState({
      isSerializedMode: !this.state.isSerializedMode,
    });
  };

  updateSelected = (selected, checkOutId) => {
    const newSelected = this.state.selected.map((s) => {
      if (s.serialNumber === selected.serialNumber) {
        let checkout = s.checkOut.find((co) => co.id == checkOutId);
        checkout.value = selected.unit;
      }
      return s;
    });

    this.setState({ selected: newSelected });
  };

  checkSelected = (serializedProduct) => {
    const newSelected = this.state.serializedProducts.map((s) => {
      if (s.serialNumber === serializedProduct.serialNumber) {
        s.checked = !s.checked;
      }
      return s;
    });

    const selected = newSelected.filter(
      (serializedProduct) => serializedProduct.checked
    );

    this.setState({
      serializedProducts: newSelected,
      selected: selected,
    });
  };

  sortBySelected = () => {
    const { direction, serializedProducts } = this.state;
    this.setState({
      direction: !direction,
      serializedProducts: sortSerializedProducts(
        !direction,
        serializedProducts
      ),
    });
  };

  setBarcodeInput = (value) => {
    this.setState({
      barcodeInput: value,
    });
  };

  onBarcodeDetected = (detections) => {
    const scannedValue = detections[0].data;

    this.setState({
      lastScannedSerial: scannedValue,
    });

    this.handleChange({
      target: {
        name: 'serialNumber',
        value: scannedValue,
      },
    });

    this.performSearch();
  };

  render() {
    const { product, open, item } = this.props;
    const {
      serialNumber,
      selected,
      isSerializedMode,
      pickedQuantity,
      serializedProducts,
      loading,
      searching,
      barcodeInput,
      lastScannedSerial,
    } = this.state;

    return (
      <Modal
        open={open}
        toggle={this.closeModal}
        large={true}
        className='serializedModal pickModal'
        title='Check Out Serialized Inventory'
        actions={[
          <a className='btn' onClick={this.handleSubmit}>
            Check Out Items
          </a>,
          <a className='btn cancel' onClick={this.closeModal}>
            Cancel
          </a>,
        ]}
      >
        <div className='form'>
          <p>{item.name}</p>
          {isSerializedMode ? (
            <div>
              <form className='fullForm' onSubmit={this.performSearch}>
                {!barcodeInput && (
                  <>
                    <input
                      type='text'
                      name='serialNumber'
                      className='barcode'
                      onChange={this.handleChange}
                      value={serialNumber}
                      autoFocus
                    />
                    <input
                      type='submit'
                      value='Add Item to Check-Out List'
                      className='btn'
                      disabled={searching}
                    />
                    <a
                      className='barcode-choose-input'
                      onClick={() => this.setBarcodeInput(true)}
                    >
                      📷 Scan barcode using camera
                    </a>
                  </>
                )}

                {barcodeInput && (
                  <>
                    <BarcodeReader onDetected={this.onBarcodeDetected} />
                    <a
                      className='barcode-choose-input'
                      onClick={() => this.setBarcodeInput(false)}
                    >
                      Enter barcode manually
                    </a>
                  </>
                )}
              </form>
              <section>
                <h4>Check-Out Serialized Inventory</h4>
                <strong><h6 style={{display: 'inline'}}>Selected</h6> <span style={{color: '#278ADA'}}>{selected.length}</span>/{this.props.item?.quantity}</strong>
                <Infinite
                  className='infinite'
                  elementHeight={40 * (serializedProducts?.length || 1)}
                  preloadBatchSize={40 * serializedProducts.length}
                  useWindowAsScrollContainer={false}
                  containerHeight={300}
                  infiniteLoadBeginEdgeOffset={100}
                  onInfiniteLoad={this.addRows}
                  loadingSpinnerDelegate={<LoadingSpinner />}
                  isInfiniteLoading={loading}
                >
                  <SerializedInventoryTable
                    selected={selected}
                    serializedProducts={serializedProducts}
                    updateSelected={this.updateSelected}
                    checkSelected={this.checkSelected}
                    sortBySelected={this.sortBySelected}
                    lastScannedSerial={lastScannedSerial}
                  />
                </Infinite>
              </section>
            </div>
          ) : (
            <div className='fields'>
              <p>How many items need to be Checked-Out?</p>
              <input
                type='text'
                name='pickedQuantity'
                className='sm'
                onChange={this.handleChange}
                value={pickedQuantity}
              />
            </div>
          )}
          {/*
          <a id='check_out_type_toggle' onClick={this.toggleIsSerializedMode}>
            {isSerializedMode
              ? 'Check Out Serialized Items without using Serial Numbers'
              : 'Check Out Serialized Items using Serial Numbers'}
          </a>
          */}
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { rental } = ownProps.overwriteRental || state.rental;
  const { loading } = state.rental;
  const { errors } = state.dashboard;
  return { rental, loading, errors };
};

export default connect(mapStateToProps, actions)(SerializedUniquePickModal);
